import React, { useEffect, useState } from "react"

const SIZE = 68
const STROKE = 4
const ANIMATION_MS = 800

function getScoreColor(value) {
    if (value >= 80) {
        return "#28a745"
    }
    if (value >= 50) {
        return "#ffc107"
    }
    return "#dc3545"
}

function easeOutCubic(progress) {
    return 1 - Math.pow(1 - progress, 3)
}

export default function PPMatchingScoreRing({ score }) {
    const targetValue = Math.max(0, Math.min(100, score ?? 0))
    const radius = (SIZE - STROKE) / 2
    const circumference = 2 * Math.PI * radius
    const center = SIZE / 2

    const [displayValue, setDisplayValue] = useState(0)
    const [ringOffset, setRingOffset] = useState(circumference)

    useEffect(() => {
        let frameId = null
        const start = performance.now()

        const animate = (now) => {
            const progress = Math.min((now - start) / ANIMATION_MS, 1)
            const eased = easeOutCubic(progress)
            const current = Math.round(targetValue * eased)
            setDisplayValue(current)
            setRingOffset(circumference - (current / 100) * circumference)
            if (progress < 1) {
                frameId = requestAnimationFrame(animate)
            }
        }

        setDisplayValue(0)
        setRingOffset(circumference)
        frameId = requestAnimationFrame(animate)

        return () => {
            if (frameId !== null) {
                cancelAnimationFrame(frameId)
            }
        }
    }, [targetValue, circumference])

    const color = getScoreColor(targetValue)

    return (
        <div className="pp-matching-score-ring" style={{ width: SIZE, height: SIZE }}>
            <svg className="pp-matching-score-ring__svg" width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
                <circle
                    className="pp-matching-score-ring__track"
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    strokeWidth={STROKE}
                />
                <circle
                    className="pp-matching-score-ring__progress"
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    stroke={color}
                    strokeWidth={STROKE}
                    strokeDasharray={circumference}
                    strokeDashoffset={ringOffset}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${center} ${center})`}
                />
            </svg>
            <span className="pp-matching-score-ring__label" style={{ color }}>
                {displayValue}%
            </span>
        </div>
    )
}
